import * as actions from './test-page.actions'
import { Answer } from 'src/services/ds.service'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, Option, some, option } from 'fp-ts/lib/Option'
import { Reducer } from 'src/framework'
import { TestResolver } from '@yobora/models/models'

export interface TestWithAnswers {
  content: TestResolver.PublicTestSession
  token: string
  answers: Answer[]
  latest: boolean
}

export interface TestPageState {
  test: Option<TestWithAnswers>
}

export const testPageStateLense = Lens.fromProp<TestPageState>()('test')

export const answersLense = Lens.fromProps<TestWithAnswers>()(['answers', 'latest'])

export const testPageLense = Lens.fromProp<TestPageState>()('test')

export const contentLense = Lens.fromProp<TestWithAnswers>()('content')

export const initialTestPageState: TestPageState = {
  test: none
}

export const sameState: (s: TestPageState) => TestPageState = identity

export const testPageReducer: Reducer<actions.TestPageActions, TestPageState> = actions.testPageActions.match({
  LoadTestSuccess: action => testPageLense.set(some(action.test)),
  LoadTestFailed: _action => testPageLense.set(none),
  SaveTestSuccess: action =>
    testPageLense.modify(prev =>
      option.map(prev, twa =>
        (twa.token === action.token ? answersLense.set({ answers: action.answers, latest: action.latest }) : identity)(
          twa
        )
      )
    ),
  SendInvitesSuccess: _action =>
    testPageLense.modify(prev =>
      option.map(prev, twa =>
        contentLense.set({
          testFinished: twa.content.testFinished,
          email: twa.content.email,
          firstName: twa.content.firstName,
          lastName: twa.content.lastName,
          test: twa.content.test,
          invitations: twa.content.invitations,
          invitationsSent: true
        })(twa)
      )
    ),
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/tests-components/test-page/test-page.reducer.ts